import React from 'react';
import MuiListItemText, { ListItemTextProps } from '@mui/material/ListItemText';

export type { ListItemTextProps };

export const ListItemText: React.FC<ListItemTextProps> = (props) => {
  return <MuiListItemText {...props} />;
};
